import { useContext } from 'react';
import { useRouter } from 'next/router';
import Header from '../../../components/Header';
import { headerLink } from '../../../navigation/function';
import { staffNavigation } from '../../../navigation/staff';
import MarketingNavigation from '../../../navigation/marketing';
import Layout from '../../../components/Layout';
import NotificationView from '../../../components/Notification/NotificationView';
import { UserContext } from '../../../components/Context/userContext';

export default function StaffCreateNotifications() {
    const router = useRouter();
    const notificationLink = headerLink(staffNavigation.notification);
    const staffLink = headerLink(staffNavigation.staff);
    const pageLink = headerLink(
        {
            name: "Create Notification",
            href: router.asPath,
        },
        true
    );
    const { state: userContext, update: updateUser } = useContext(UserContext);

    return (
        <MarketingNavigation isAdmin>
            <Layout>
                {userContext?.user?.isStaff ? (
                    <div>
                        <Header>
                            Staff | {staffLink} | {notificationLink} | {pageLink}
                        </Header>
                        <NotificationView view="create"></NotificationView>
                    </div>
                ) : (
                    <></>
                )}
            </Layout>
        </MarketingNavigation>
    );
}

StaffCreateNotifications.getLayout = (page) => <>{page}</>;
StaffCreateNotifications.isStaff = true;
